import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../shared/logger';

export class Recruiter {
    static getName = (recruiter) => recruiter.fullName;

    static getFirstWorkingEmail = (recruiter) => {
        const emails = _.get(recruiter, 'contact.email', []);
        const emailsFiltered = emails.filter(({ value }) => Boolean(value));
        const firstWorkingEmail = _.find(emailsFiltered, (email) => email.type === 'Work');

        const result = _.get(firstWorkingEmail, 'value');
        return result;
    }

    static getFirstEmail = (recruiter) => {
        const emails = _.get(recruiter, 'contact.email', []);
        const emailsFiltered = emails.filter(({ value }) => Boolean(value));
        const firstWorkingEmail = _.get(emailsFiltered, '[0]');

        const result = _.get(firstWorkingEmail, 'value');
        return result;
    }

    static getEmail = (recruiter) => Recruiter.getFirstWorkingEmail(recruiter) || Recruiter.getFirstEmail(recruiter);
}

export const RecruiterService = (Restangular) => {
    const getRecruiters = function (projection = []) {
        return Restangular.all('recruiters')
            .post({ projection })
            .catch((error) => Logger.error(error));
    };

    const getAllRecruitersForMenu = function () {
        return Restangular.all('recruiters')
            .post({ projection: ['fullName', 'contact.email'] })
            .catch((error) => Logger.error(error));
    };

    const getRecruiter = function (id) {
        return Restangular.one('recruiter', id)
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getTalenyaBotRecruiter = function () {
        const recruiterId = 'talenyaBot';
        return Restangular.one('recruiter', recruiterId)
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getRecruiterWorkflowCounters = function (id, body) {
        return Restangular.one('recruiter', id)
            .all('workflowCounters')
            .post(body)
            .catch((error) => Logger.error(error));
    };

    const claimJob = function (recruiterId, positionId) {
        return Restangular.one('recruiter', recruiterId)
            .one('position', positionId)
            .all('claim')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const claimAndGetPosition = (recruiterId, positionId) => Restangular.one('recruiter', recruiterId)
        .one('position', positionId)
        .all('claimAndGetPosition')
        .post()
        .catch((error) => Logger.error(error));

    const unClaimJob = function (recruiterId, positionId) {
        return Restangular.one('recruiter', recruiterId)
            .one('position', positionId)
            .all('unclaim')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const changeRecruiterStatus = function (recruiterId, positionId, data) {
        return Restangular.one('recruiter', recruiterId)
            .one('position', positionId)
            .all('status')
            .customPUT(data)
            .catch((error) => Logger.error(error));
    };

    const postRecruiter = function (data) {
        return Restangular.all('recruiter')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const putRecruiter = function (id, data) {
        return Restangular.one('recruiter', id)
            .customPUT(data)
            .catch((error) => Logger.error(error));
    };

    const postRecruiterSearch = function (data) {
        return Restangular.all('recruiter')
            .all('search')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const hideRecruiterPosition = function (recruiterId, positionId) {
        return Restangular.one('recruiter', recruiterId)
            .one('position', positionId)
            .all('hide')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const unhideRecruiterPosition = function (recruiterId, positionId) {
        return Restangular.one('recruiter', recruiterId)
            .one('position', positionId)
            .all('unhide')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const sendResmueToEmployer = function (data) {
        return Restangular.all('email')
            .all('sendResumeToEmployer')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const getPositions = function ({
        recruiterId, filters, pageOptions, sort,
    }) {
        return Restangular.one('recruiter', recruiterId)
            .all('getPositions')
            .post({ filters, pageOptions, sort })
            .catch((error) => Logger.error(error));
    };

    const getOpenPositions = function (data) {
        return Restangular.all('recruiter')
            .all('openPositions')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const addRole = function (recruiterId, role) {
        return Restangular.one('recruiter', recruiterId)
            .all('addRole')
            .customPUT({ role })
            .catch((error) => Logger.error(error));
    };

    const removeRole = function (recruiterId, role) {
        return Restangular.one('recruiter', recruiterId)
            .all('removeRole')
            .customPUT({ role })
            .catch((error) => Logger.error(error));
    };

    const getAllRecruitersEmails = async () => {
        try {
            const { result: recruiters } = await getRecruiters(['contact.email']);

            const emails = _.chain(recruiters)
                .map('contact.email')
                .flatten()
                .map('value')
                .filter(Boolean)
                .value();

            return emails;
        } catch (error) {
            Logger.error(error);
        }
    };

    const setStatus = (recruiterId, status) => {
        return status
            ? activate(recruiterId)
            : deactivate(recruiterId);
    }

    const activate = function (recruiterId) {
        return Restangular.one('recruiter', recruiterId)
            .all('activate')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const deactivate = function (recruiterId) {
        return Restangular.one('recruiter', recruiterId)
            .all('deactivate')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    return {
        getRecruiters,
        getRecruiter,
        getRecruiterWorkflowCounters,
        getTalenyaBotRecruiter,
        claimJob,
        claimAndGetPosition,
        unClaimJob,
        changeRecruiterStatus,
        putRecruiter,
        postRecruiter,
        postRecruiterSearch,
        hideRecruiterPosition,
        unhideRecruiterPosition,
        sendResmueToEmployer,
        getPositions,
        getOpenPositions,
        removeRole,
        addRole,
        getAllRecruitersEmails,
        getAllRecruitersForMenu,
        activate,
        deactivate,
        setStatus,
    };
};

angular.module('TALENYA-FE')
    .factory('RecruiterService', RecruiterService);
